import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { 
  FaGraduationCap, 
  FaChartBar, 
  FaBook, 
  FaFileAlt,
  FaBuilding,
  FaEnvelope,
  FaPhone,
  FaOrcid,
  FaTable,
  FaUserGraduate,
  FaSortAmountDown,
  FaSortAmountUp
} from 'react-icons/fa';
import { 
  SiResearchgate, 
  SiScopus, 
  SiGooglescholar 
} from 'react-icons/si';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import PageHeader from '../../components/PageHeader/PageHeader';
import Table from '../../components/Table/Table';
import styles from './AkademisyenDetay.module.css';
import SummaryCard from '../../components/SummaryCard/SummaryCard';

const AkademisyenDetay = () => {
  const { id } = useParams();
  const [sortField, setSortField] = useState(null);
  const [sortDirection, setSortDirection] = useState('asc');

  const ituOzetBilgileri = {
    ogretimUyesiSayisi: 1231,
    makaleVeReviewSayisi2024: 2064,
    ogretimUyesiBasinaQ1Q22024: 1.54,
    ogretimUyesiBasinaMRSayisi2024: 1.68,
    ogretimUyesiBasinaQ12024: 1.15,
    ogretimUyesiBasinaQ22024: 0.40,
    q12024: 1409,
    q22024: 488,
    q1q22024: 1897,
    q1Yuzdesi: 68.3,
    q2Yuzdesi: 23.6,
    q1q2Yuzdesi: 91.9
  };
  
  const toplamMakaleBilgileri = {
    toplamMakale2024: 2064,
    toplamMakaleSonBesYil: 9461,
    q1: {
      sayi2024: 1409,
      yuzde2024: 69.3,
      sonBesYil: 5798
    },
    q2: {
      sayi2024: 488,
      yuzde2024: 23.6,
      sonBesYil: 2058
    },
    mr: {
      sayi2024: 137,
      sonBesYil: 1007
    }
  };

  const summaryData = {
    totalArticles: {
      title: "Toplam Makale",
      description: "Toplam makale sayısı",
      currentYear: toplamMakaleBilgileri.toplamMakale2024,
      lastFiveYears: toplamMakaleBilgileri.toplamMakaleSonBesYil
    },
    q1Articles: {
      title: "Q1 Makaleler",
      description: "Q1 kategorisindeki makaleler",
      currentYear: toplamMakaleBilgileri.q1.sayi2024,
      percentage: toplamMakaleBilgileri.q1.yuzde2024,
      total: toplamMakaleBilgileri.q1.sonBesYil
    },
    q2Articles: {
      title: "Q2 Makaleler",
      description: "Q2 kategorisindeki makaleler",
      currentYear: toplamMakaleBilgileri.q2.sayi2024,
      percentage: toplamMakaleBilgileri.q2.yuzde2024,
      total: toplamMakaleBilgileri.q2.sonBesYil
    },
    mrArticles: {
      title: "M/R Makaleler",
      description: "Makale ve Review sayıları",
      currentYear: toplamMakaleBilgileri.mr.sayi2024,
      total: toplamMakaleBilgileri.mr.sonBesYil
    },
    facultyStats: {
      title: "Öğretim Üyesi İstatistikleri",
      description: "Öğretim üyesi başına düşen yayın sayıları",
      totalFaculty: ituOzetBilgileri.ogretimUyesiSayisi,
      articlesPerFaculty: ituOzetBilgileri.ogretimUyesiBasinaMRSayisi2024,
      q1q2PerFaculty: ituOzetBilgileri.ogretimUyesiBasinaQ1Q22024,
      mrPerFaculty: ituOzetBilgileri.ogretimUyesiBasinaMRSayisi2024
    }
  };
  const akademisyen = {
    id,
    adSoyad: 'Prof. Dr. Lorem Ipsum',
    unvan: 'Profesör',
    fakulte: 'Mühendislik Fakültesi',
    bolum: 'Bilgisayar Mühendisliği',
    email: 'lorem.ipsum@example.com',
    telefon: '+90 555 123 4567',
    foto: 'https://randomuser.me/api/portraits/men/1.jpg',
    orcidId: '0000-0002-1234-5678',
    researchId: 'A-1234-5678',
    scopusId: '57123456789',
    googleScholarId: 'ABC123',
    bolumDetay: {
      toplamOgretimUyesi: 30,
      toplamDoktoraOgrenci: 45,
      toplamYuksekLisansOgrenci: 120,
      toplamProje: 25,
      toplamButce: '₺15.5M',
      performansGostergeleri: {
        q1Yuzdesi: 45.8,
        q2Yuzdesi: 32.1,
        atifSayisi: 2500,
        hIndex: 25
      }
    },
    bransDetails: {
      brans: 'Bilgisayar Mühendisliği',
      uzmanlikAlanlari: ['Yapay Zeka', 'Makine Öğrenmesi', 'Veri Madenciliği', 'Büyük Veri Analizi'],
      akademikUnvan: 'Profesör',
      kadroTipi: 'Tam Zamanlı',
      gorevBaslamaTarihi: '2010-09-01',
      doktoraBitirme: '2005',
      docentlikAlma: '2008',
      arastirmaAlanlari: [
        'Derin Öğrenme Modelleri',
        'Doğal Dil İşleme',
        'Bilgisayarlı Görü',
        'Robot Öğrenmesi'
      ],
      projeler: {
        yurutulen: 3,
        tamamlanan: 12,
        toplamButce: '₺5.2M'
      },
      ogrenciSayilari: {
        doktora: 5,
        yuksekLisans: 8,
        lisans: 15
      }
    },
    yayinHedefler: [
      { yil: '2024', hedef: 5, gerceklesen: 1, not: 'Q1 kategorisinde 2 yayın hedefi var' },
      { yil: '2023', hedef: 4, gerceklesen: 4, not: 'Hedef tamamlandı' },
      { yil: '2022', hedef: 3, gerceklesen: 4, not: 'Hedef aşıldı' },
      { yil: '2021', hedef: 3, gerceklesen: 3, not: 'Hedef tamamlandı' }
    ],
    yayinDetay: {
      q1Count: 15,
      q2Count: 12,
      q3Count: 8,
      q4Count: 5,
      dmrCount: 3,
      digerCount: 2
    },
    ozetBilgiler: [
      {
        title: 'Toplam Yayın Sayısı',
        value: '45',
        subValue: '2023 yılında: +5',
        description: 'Son 5 yılda ortalama yıllık artış: 4.2',
        icon: <FaBook />,
        color: 'badge-success'
      },
      {
        title: 'Öğretim Üyesi Başına Düşen Q1-Q2',
        value: '2.8',
        subValue: 'Hedef: 3.0',
        description: 'Hedefe ulaşmak için gereken: 1 yayın',
        icon: <FaChartBar />,
        color: 'badge-warning'
      },
      {
        title: 'Atıf Sayısı',
        value: '1,250',
        subValue: '2023 yılında: +150',
        description: 'H-index: 15 | i10-index: 25',
        icon: <FaGraduationCap />,
        color: 'badge-info'
      },
      {
        title: 'Proje Sayısı',
        value: '8',
        subValue: 'Aktif: 3',
        description: 'Toplam Bütçe: ₺2.5M',
        icon: <FaFileAlt />,
        color: 'badge-danger'
      }
    ],
    notlar: [
      {
        tarih: '2024-01-05',
        icerik: 'Q1 kategorisinde 2 yeni yayın hedefi belirlendi.'
      },
      {
        tarih: '2023-12-15',
        icerik: 'TÜBİTAK 1001 projesi başvurusu yapıldı.'
      },
      {
        tarih: '2023-12-01',
        icerik: 'Yeni doktora öğrencisi danışmanlığı başladı.'
      }
    ]
  };

  const summaryCards = [
    {
      title: 'Q1',
      year: '2024',
      value: '4B',
      yearValue: '4B',
      color: 'success'
    },
    {
      title: 'Q2',
      year: '2024',
      value: '0',
      yearValue: '0',
      color: 'info'
    },
    {
      title: 'D. M/R',
      year: '2024',
      value: '0',
      yearValue: '0',
      color: 'warning'
    },
    {
      title: 'Diğer',
      year: '2024',
      value: '1B',
      yearValue: '1B',
      color: 'danger'
    }
  ];

  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
  };

  const publicationsColumns = [
    {
      title: 'Yıl',
      dataIndex: 'yil',
      key: 'yil',
      width: '10%',
      sorter: true,
      render: (text, record) => (
        <div className={styles['sort-header']}>
          {text}
          {sortField === 'yil' && (
            <span className={styles['sort-icon']}>
              {sortDirection === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />}
            </span>
          )}
        </div>
      )
    },
    {
      title: 'Q1',
      dataIndex: 'q1',
      key: 'q1',
      width: '10%'
    },
    {
      title: 'Q2',
      dataIndex: 'q2',
      key: 'q2',
      width: '10%'
    },
    {
      title: 'Q3',
      dataIndex: 'q3',
      key: 'q3',
      width: '10%'
    },
    {
      title: 'Q4',
      dataIndex: 'q4',
      key: 'q4',
      width: '10%'
    },
    {
      title: 'Toplam',
      dataIndex: 'toplam',
      key: 'toplam',
      width: '10%'
    }
  ];

  const publicationsData = [
    {
      key: '2023',
      yil: '2023',
      q1: 3,
      q2: 2,
      q3: 1,
      q4: 0,
      toplam: 6
    },
    {
      key: '2022',
      yil: '2022',
      q1: 4,
      q2: 3,
      q3: 2,
      q4: 1,
      toplam: 10
    },
    {
      key: '2021',
      yil: '2021',
      q1: 2,
      q2: 2,
      q3: 1,
      q4: 1,
      toplam: 6
    },
    {
      key: 'total',
      yil: 'Toplam',
      q1: 9,
      q2: 7,
      q3: 4,
      q4: 2,
      toplam: 22,
      isTotal: true
    }
  ];

  const breadcrumbs = [
    { text: 'Ana Sayfa', href: '/' },
    { text: 'Akademisyenler', href: '/akademisyenler' },
    { text: akademisyen.adSoyad, href: null }
  ];

  const chartOptions = {
    chart: {
      type: 'column',
      height: 350,
      style: {
        fontFamily: '-apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
      }
    },
    title: {
      text: null
    },
    xAxis: {
      categories: ['2019', '2020', '2021', '2022', '2023', '2024'],
      crosshair: true,
      labels: {
        style: {
          color: '#6b7280'
        }
      }
    },
    yAxis: {
      min: 0,
      title: {
        text: 'Yayın Sayısı',
        style: {
          color: '#6b7280'
        }
      },
      labels: {
        style: {
          color: '#6b7280'
        }
      },
      gridLineColor: '#e5e7eb'
    },
    legend: {
      align: 'right',
      verticalAlign: 'top',
      symbolRadius: 2,
      itemStyle: {
        color: '#6b7280',
        fontWeight: 'normal',
        fontSize: '12px'
      }
    },
    tooltip: {
      shared: true,
      backgroundColor: '#ffffff',
      borderColor: '#e5e7eb',
      borderRadius: 6,
      shadow: true,
      useHTML: true,
      headerFormat: '<table><tr><td colspan="2"><b>{point.key}</b></td></tr>',
      pointFormat: '<tr><td style="color: {series.color}">{series.name}: </td><td style="text-align: right"><b>{point.y}</b></td></tr>',
      footerFormat: '</table>'
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
        borderRadius: 4,
        groupPadding: 0.1
      },
      series: {
        animation: {
          duration: 1000
        }
      }
    },
    series: [
      {
        name: 'Hedef',
        color: '#e5e7eb',
        data: [3, 3, 3, 3, 4, 5]
      },
      {
        name: 'Gerçekleşen',
        color: '#3b82f6',
        data: [2, 3, 3, 4, 4, 1]
      }
    ],
    credits: {
      enabled: false
    },
    responsive: {
      rules: [{
        condition: {
          maxWidth: 500
        },
        chartOptions: {
          legend: {
            align: 'center',
            verticalAlign: 'bottom'
          }
        }
      }]
    }
  };

  return (
    <div className={styles.wrapper}>
      <PageHeader
        title="Akademisyen Detay"
        breadcrumbs={breadcrumbs}
      />

      <div className={styles['summary-cards']}>
        {summaryCards.map((card, index) => (
          <div key={index} className={`${styles['summary-stat-card']} ${styles[`card-${card.color}`]}`}>
            <div className={styles['stat-header']}>
              <h3>{card.title}</h3>
              <span className={styles['stat-year']}>{card.year}</span>
            </div>
            <div className={styles['stat-body']}>
              <div className={styles['stat-main']}>
                <span className={styles['stat-value']}>{card.value}</span>
              </div>
              <div className={styles['stat-footer']}>
                <span>Son Beş Yıl</span>
                <span className={styles['year-value']}>{card.yearValue}</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className={styles['profile-card']}>
        <div className={styles['profile-info']}>
          <img src={akademisyen.foto} alt={akademisyen.adSoyad} className={styles['profile-photo']} />
          <div className={styles['profile-details']}>
            <h2 className={styles.name}>{akademisyen.adSoyad}</h2>
            <p className={styles.title}>{akademisyen.unvan}</p>
            <div className={styles['institution-info']}>
              <p>
                <FaBuilding />
                {akademisyen.fakulte} - {akademisyen.bolum}
              </p>
              <p>
                <FaEnvelope />
                {akademisyen.email}
              </p>
              <p>
                <FaPhone />
                {akademisyen.telefon}
              </p>
            </div>
            <div className={styles['academic-ids']}>
              <p>
                <FaOrcid style={{ color: '#A6CE39' }} />
                <a href={`https://orcid.org/${akademisyen.orcidId}`} target="_blank" rel="noopener noreferrer">
                  {akademisyen.orcidId}
                </a>
              </p>
              <p>
                <SiResearchgate style={{ color: '#00CCBB' }} />
                <a href={`https://www.researcherid.com/${akademisyen.researchId}`} target="_blank" rel="noopener noreferrer">
                  Research ID: {akademisyen.researchId}
                </a>
              </p>
              <p>
                <SiScopus style={{ color: '#E9711C' }} />
                <a href={`https://www.scopus.com/authid/detail.uri?authorId=${akademisyen.scopusId}`} target="_blank" rel="noopener noreferrer">
                  Scopus ID: {akademisyen.scopusId}
                </a>
              </p>
            </div>
            <div className={styles['branch-details']}>
              <h3 className={styles['section-title']}>
                <FaUserGraduate />
                Branş Bilgileri
              </h3>
              <div className={styles['branch-info-grid']}>
                <div className={styles['branch-info-item']}>
                  <span className={styles['info-label']}>Uzmanlık Alanları:</span>
                  <span className={styles['info-value']}>{akademisyen.bransDetails.uzmanlikAlanlari.join(', ')}</span>
                </div>
                <div className={styles['branch-info-item']}>
                  <span className={styles['info-label']}>Göreve Başlama:</span>
                  <span className={styles['info-value']}>{akademisyen.bransDetails.gorevBaslamaTarihi}</span>
                </div>
                <div className={styles['branch-info-item']}>
                  <span className={styles['info-label']}>Doktora:</span>
                  <span className={styles['info-value']}>{akademisyen.bransDetails.doktoraBitirme}</span>
                </div>
                <div className={styles['branch-info-item']}>
                  <span className={styles['info-label']}>Doçentlik:</span>
                  <span className={styles['info-value']}>{akademisyen.bransDetails.docentlikAlma}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid px-0 mb-4">
        <div className="row">
          <div className="col-md-8">
            <div className={styles['chart-card']}>
              <div className="card-header">
                <h3 className={styles['card-title']}>
                  <FaChartBar />
                 Yayın Performansı
                </h3>
              </div>
              <div className={styles['publication-targets']}>
                <div className={styles['target-table']}>
                  <table>
                    <thead>
                      <tr>
                        <th>Yıl</th>
                        <th>Hedef</th>
                        <th>Gerçekleşen</th>
                        <th>Not</th>
                      </tr>
                    </thead>
                    <tbody>
                      {akademisyen.yayinHedefler.map((hedef, index) => (
                        <tr key={index}>
                          <td>{hedef.yil}</td>
                          <td>{hedef.hedef}</td>
                          <td>{hedef.gerceklesen}</td>
                          <td>{hedef.not}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <HighchartsReact highcharts={Highcharts} options={chartOptions} />
            </div>
          </div>
          <div className="col-md-4">
            <div className={styles['notes-card']}>
              <div className="card-header">
                <h3 className={styles['card-title']}>
                    <FaFileAlt />
                    Notlar
                </h3>
              </div>
              <div className={styles['notes-list']}>
                {akademisyen.notlar.map((not, index) => (
                  <div key={index} className={styles['note-item']}>
                    <p className={styles['note-date']}>{not.tarih}</p>
                    <p className={styles['note-content']}>{not.icerik}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        

      </div>

      <div className={styles['publications-card'] + ' mb-4'}>
        
        <div className="card-header">
          <h3 className={styles['card-title']}>
            <FaBook />
            Yayınlar
          </h3>
        </div>
        <div className={styles['publication-stats']}>
          <div className={styles['stat-item']}>
            <span className={styles['stat-label']}>Q1:</span>
            <span className={styles['stat-value']}>{akademisyen.yayinDetay.q1Count}</span>
          </div>
          <div className={styles['stat-item']}>
            <span className={styles['stat-label']}>Q2:</span>
            <span className={styles['stat-value']}>{akademisyen.yayinDetay.q2Count}</span>
          </div>
          <div className={styles['stat-item']}>
            <span className={styles['stat-label']}>Q3:</span>
            <span className={styles['stat-value']}>{akademisyen.yayinDetay.q3Count}</span>
          </div>
          <div className={styles['stat-item']}>
            <span className={styles['stat-label']}>Q4:</span>
            <span className={styles['stat-value']}>{akademisyen.yayinDetay.q4Count}</span>
          </div>
          <div className={styles['stat-item']}>
            <span className={styles['stat-label']}>D. M/R:</span>
            <span className={styles['stat-value']}>{akademisyen.yayinDetay.dmrCount}</span>
          </div>
          <div className={styles['stat-item']}>
            <span className={styles['stat-label']}>Diğer:</span>
            <span className={styles['stat-value']}>{akademisyen.yayinDetay.digerCount}</span>
          </div>
        </div>
        <Table
          columns={publicationsColumns}
          data={publicationsData}
          rowClassName={record => record.isTotal ? 'total-row' : ''}
        />
      </div>

    
    
      <div className={styles['publications-card']}>
        <div className="card-header">
          <h3 className={styles['card-title']}>
            <FaBook />
            Bilgisayar Mühendisliği Bölüm Bilgileri
          </h3>
        </div>

          <div className="summary-cards-grid container-fluid">
              <div class="row">
                <div class="col-md-4">
                    <SummaryCard
                      type="totalArticles"
                      title={summaryData.totalArticles.title}
                      description={summaryData.totalArticles.description}
                      data={{
                        "Bu Yıl": summaryData.totalArticles.currentYear,
                        "Son 5 Yıl": summaryData.totalArticles.lastFiveYears
                      }}
                    />
                </div>
                <div class="col-md-4">
                  <SummaryCard
                    type="q1Articles"
                    title={summaryData.q1Articles.title}
                    description={summaryData.q1Articles.description}
                    data={{
                      "Bu Yıl": summaryData.q1Articles.currentYear,
                      "Yüzde": `%${summaryData.q1Articles.percentage}`,
                      "Toplam": summaryData.q1Articles.total
                    }}
                  />
                </div>
                <div class="col-md-4">
                    <SummaryCard
                      type="q2Articles"
                      title={summaryData.q2Articles.title}
                      description={summaryData.q2Articles.description}
                      data={{
                        "Bu Yıl": summaryData.q2Articles.currentYear,
                        "Yüzde": `%${summaryData.q2Articles.percentage}`,
                        "Toplam": summaryData.q2Articles.total
                      }}
                    />
                </div>
                <div class="col-md-4">
                  <SummaryCard
                    type="mrArticles"
                    title={summaryData.mrArticles.title}
                    description={summaryData.mrArticles.description}
                    data={{
                      "Bu Yıl": summaryData.mrArticles.currentYear,
                      "Toplam": summaryData.mrArticles.total
                    }}
                  />
                </div>
                <div class="col-md-4">
                  <SummaryCard
                    type="facultyStats"
                    title={summaryData.facultyStats.title}
                    description={summaryData.facultyStats.description}
                    data={{
                      "Toplam": summaryData.facultyStats.totalFaculty,
                      "Yayın/Üye": summaryData.facultyStats.articlesPerFaculty,
                      "Q1+Q2/Üye": summaryData.facultyStats.q1q2PerFaculty,
                      "M-R/Üye": summaryData.facultyStats.mrPerFaculty
                    }}
                  />
                </div>


              </div>

          
            </div>
      </div>
    </div>
  );
};

export default AkademisyenDetay;